import { SuccessButton } from "@rpforms/shared";
import {
    createSickDay,
    deleteSickDay,
    updateSickDay,
} from "@rpforms/shared/build/actions/employees";
import { SmallDangerButton, SmallPrimaryButton } from "@rpforms/shared/build/components/Button";
import moment from "moment";
import React, { useState } from "react";
import { DateRangePicker } from "react-dates";
import { useDispatch } from "react-redux";

const toMoment = (value) => (value ? moment(value, "YYYY-MM-DD") : null);

export const EmployeeSickDay = ({ employeeId, sickDay = null }) => {
    const dispatch = useDispatch();
    const isNew = !sickDay;
    const [editing, setEditing] = useState(isNew);
    const [from, setFrom] = useState(toMoment(sickDay?.from));
    const [to, setTo] = useState(toMoment(sickDay?.to));
    const [note, setNote] = useState(sickDay?.note || "");
    const [focusedInput, setFocusedInput] = useState(null);
    const idPrefix = `sick_day_${sickDay?.id || "new"}`;

    const payload = () => ({
        id: sickDay?.id,
        employee_id: employeeId,
        sick_day: {
            from: from?.format("YYYY-MM-DD"),
            to: (to || from)?.format("YYYY-MM-DD"),
            note,
        },
    });

    const save = () => {
        if (!from) {
            return;
        }
        dispatch(isNew ? createSickDay(payload()) : updateSickDay(payload()));
    };

    const remove = () => {
        if (window.confirm("Krankheitstage wirklich löschen?")) {
            dispatch(deleteSickDay(sickDay));
        }
    };

    if (!editing) {
        return (
            <div
                style={{
                    marginTop: "20px",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "10px",
                    marginBottom: "10px",
                }}
            >
                <strong>
                    {moment(sickDay.from).format("DD.MM.YYYY")} -{" "}
                    {moment(sickDay.to).format("DD.MM.YYYY")}
                </strong>
                {sickDay.note ? ` / ${sickDay.note}` : ""}
                <SmallPrimaryButton onClick={() => setEditing(true)}>Bearbeiten</SmallPrimaryButton>
                <SmallDangerButton onClick={remove}>Löschen</SmallDangerButton>
            </div>
        );
    }

    return (
        <div
            style={{
                padding: "20px",
                marginTop: "20px",
                background: "#fff",
                border: "1px solid #ccc",
                maxWidth: "950px",
                display: "flex",
                alignItems: "flex-end",
            }}
        >
            <div style={{ marginRight: "20px" }}>
                <label>Zeitraum</label>
                <DateRangePicker
                    startDate={from}
                    startDateId={`${idPrefix}_from`}
                    endDate={to}
                    endDateId={`${idPrefix}_to`}
                    onDatesChange={({ startDate, endDate }) => {
                        setFrom(startDate);
                        setTo(endDate);
                    }}
                    minimumNights={0}
                    isOutsideRange={() => false}
                    displayFormat={"DD.MM.YYYY"}
                    focusedInput={focusedInput}
                    onFocusChange={setFocusedInput}
                />
            </div>
            <div style={{ marginRight: "20px", flex: 1 }}>
                <label>Notiz</label>
                <input
                    className="form-control"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                />
            </div>
            <SuccessButton onClick={save} disabled={!from}>
                {isNew ? "Anlegen" : "Speichern"}
            </SuccessButton>
        </div>
    );
};

export default EmployeeSickDay;
